'use strict';

var BaseModel = require('./Base');
var log       = require('lib/log')('vehicle-model');
var Model;

module.exports = Model = BaseModel.extend('Vehicle', {
    softDelete: false,

    defaults: {
        type: '',
        year: (new Date()).getFullYear(),
        model: ''
    },

    constraints: {
        type: {presence: true},
        year: {
            presence: true,
            numericality: {
                onlyIntegers: true,
                lessThanOrEqualTo: (new Date()).getFullYear()
            }
        },
        model: {presence: true}
    },

    save: function() {
        log.warn('Vehicle Model is not meant to be persisted.');
    }
}, {});



// WEBPACK FOOTER //
// ./app/models/Vehicle.js